<template>
  <lottie-player
    :src="lottieSrc"
    background="transparent"
    :speed="props.speed"
    :loop="props.loop"
    :autoplay="props.autoplay"
  ></lottie-player>
</template>

<script setup lang="ts">
import waveHand from '../../assets/lotties/hand-wave-short.json';
import login from '../../assets/lotties/login.json';
import logout from '../../assets/lotties/logout.json';
import notification from '../../assets/lotties/notification.json';

// Can't use 'resolve'/dynamic import for the moment
const LOTTIE_FILES: Record<string, unknown> = {
  handWave: waveHand,
  login: login,
  logout: logout,
  notification: notification,
};

const props = defineProps({
  name: { type: String, required: true },
  speed: { type: Number, default: 1 },
  loop: { type: Boolean, default: false },
  autoplay: { type: Boolean, default: true },
});

const lottieSrc = computed(() => {
  return LOTTIE_FILES[props.name] || null;
});
</script>
